<template>
  <div class="container--fluid">
    <nav aria-label="breadcrumb" role="navigation">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page"><a href="#/home">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page"><a href="#/Papers">Papers</a></li>
        <li class="breadcrumb-item active" aria-current="page">{{paper.fields.title}}</li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-6">
        <div class="card bg-dark text-white">
          <img class="card-img "
               :src="paper.fields.feature_img"
               alt="Card image">
          <div class="card-img-overlay d-flex align-items-end p-0">
            <span class="card-overlay p-3"><h2 class="title card-title ">{{paper.fields.title}}</h2></span>
          </div>
        </div>
        <card>
          <p v-html="paper.fields.body"></p>
        </card>
      </div>
      <div class="col-md-6">
        <youtube
          :video-id="paper.fields.youtube_id"
          player-width="100%"
        ></youtube>
        <div
          height="100%"
          id="speaker-deck"></div>
      </div>
    </div>
    <div class="row" v-if="this.prophy_data!=null">
      <div class="col-4">
        <v-card
          class="mx-auto"
          color="#26c6da"
          dark
        >
          <v-card-title>
            <span
              class="title font-weight-light">References {{ this.prophy_data.referencesTo.references.length }}</span>
          </v-card-title>

          <v-card-text class="headline font-weight-bold">
          </v-card-text>

          <v-card-actions>
            <v-list-item class="grow">

              <v-list-item-content>
                <v-list-item-action-text v-for="item in this.prophy_data.referencesTo.references">{{ item.title }}</v-list-item-action-text>
              </v-list-item-content>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </div>
      <div class="col-4">
        <v-card
          class="mx-auto"
          color="#26c6da"
          dark
        >
          <v-card-title>
            <span
              class="title font-weight-light">Citations {{ this.prophy_data.referencesFrom.references.length }}</span>
          </v-card-title>

          <v-card-text class="headline font-weight-bold">
          </v-card-text>

          <v-card-actions>
            <v-list-item class="grow">

              <v-list-item-content>
                <v-list-item-action-text v-for="item in this.prophy_data.referencesFrom.references">{{ item.title }}</v-list-item-action-text>
              </v-list-item-content>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </div>
      <div class="col-4">
        <v-card
          class="mx-auto"
          color="#26c6da"
          dark
        >
          <v-card-title>
            <span
              class="title font-weight-light">Concepts {{ this.prophy_data.article.concepts.length }}</span>
          </v-card-title>

          <v-card-text class="headline font-weight-bold">
          </v-card-text>

          <v-card-actions>
            <v-list-item class="grow">

              <v-list-item-content>
                <v-list-item-action-text v-for="item in this.prophy_data.article.concepts">{{ item.name }}</v-list-item-action-text>
              </v-list-item-content>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <v-alert
          dark>
          Meta data is provided by <a href="https://www.prophy.science/">Prophy API</a>
        </v-alert>
      </div>
    </div>
  </div>
</template>

<script>
  import Butter from 'buttercms';
  import axios from 'axios';
  import {db} from '../main.js'

  axios.defaults.baseURL = 'http://localhost:3000';
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
  axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

  const butter = Butter('05e3cf8dc2988e25603c8d13cbd9de33a9755dac');

  export default {
    name: "Paper",
    data() {
      return {
        paper: null,
        pageSize: 1,
        hasNext: false,
        sd_loaded: false,
        prophy_id: null,
        prophy_data: null,
      }
    },
    methods: {
      getPage() {
        let me = this
        butter.page.retrieve('papers',
          me.slug).then(function (response) {
          console.log("here is info on your paper")
          console.log(response.data.data)
          me.paper = response.data.data
          me.prophy_id = me.paper.fields.prophy_id
        })
      },
      basename(str) {
        let base = new String(str).substring(str.lastIndexOf('/') + 1);
        if (base.lastIndexOf(".") != -1)
          base = base.substring(0, base.lastIndexOf("."));
        return base;
      }

    },
    created() {
      this.getPage()
    },
    updated() {
      if (!this.sd_loaded) {
        let sd = document.createElement('script');

        sd.setAttribute('src', "//speakerdeck.com/assets/embed.js");
        sd.setAttribute('class', "speakerdeck-embed");
        sd.setAttribute('data-slide', "1");
        sd.setAttribute('data-id', this.paper.fields.speakerdeck_id);
        sd.setAttribute('data-ratio', (4 / 3).toString());
        document.getElementById('speaker-deck').appendChild(sd);
        this.sd_loaded = true
      }
    },
    computed: {
      slug() {
        return this.$route.params.slug
      }
    }
    ,
    watch: {
      prophy_id: function () {
        let id = this.prophy_id
        let docRef = db.collection("articles").doc(id);

        let me = this
        docRef.get().then(function (doc) {
          if (doc.exists) {
            me.prophy_data = doc.data()
            console.log("Document data:", doc.data());
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        }).catch(function (error) {
          console.log("Error getting document:", error);
        });
      }
    }
  }
</script>

<style scoped>
  .card-overlay {
    width: 100%;
    background: rgba(29, 37, 59, 0.9);
  }
</style>
